import {
  FlyoutListMenuWidget,
  HorizontalOriginOption,
  MenuButtonWidget,
  MenuItemInfo,
  OriginOptions,
  VerticalOriginOption
} from '@tableau/widgets';
import * as React from 'react';
import { useRef, useState } from 'react';

import {
  integrationSettingConnectButton,
} from '~src/app/spaces/IntegrationsSettings/styles/IntegrationsSettingsStyles';
import {
  SalesforceIntegrationAddCredentialsMenuClickEvent,
  SalesforceIntegrationExistingCredentialsClickEvent
} from '~src/app/spaces/IntegrationsSettings/telemetry/IntegrationsSettingsTelemetry';
import { Messages } from '~src/codegen/Localize';
import { IOAuthCredential } from '~src/ts/ServerApi/types/IOAuthCredential';

export interface ConnectToSalesforceDropdownProps{
  credentials: IOAuthCredential[];
  handleSelectedItem: (credentialId: number) => void;
  handleAddNewCredentials: () => void;
}

export const ConnectToSalesforce = 'connect-to-salesforce';
export const NewSalesforceConnectionValue = 'newSalesforceConnection';
export const ConnectToSalesforceMenuId = `${ConnectToSalesforce}-menu`;

function ConnectToSalesforceDropdown(props: ConnectToSalesforceDropdownProps)
{
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const connectToSalesforceMenuAnchor = useRef();

  const menuClick = (): void => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = (): void => {
    setIsMenuOpen(false);
  };

  const onSelectContextMenuItem = (oauthId: string): void => {
    if (oauthId === NewSalesforceConnectionValue)
    {
      SalesforceIntegrationAddCredentialsMenuClickEvent();
      props.handleAddNewCredentials();
    } else {
      SalesforceIntegrationExistingCredentialsClickEvent();
      executeContextMenuCommand(parseInt(oauthId));
    }
    setIsMenuOpen(false);
  };

  const buildMenuItems = () => {
    let menuItems: MenuItemInfo[] = [];
    if (props.credentials && props.credentials.length > 0) {
      props.credentials.forEach(cred => {
        cred && menuItems.push({value:cred.id, displayValue: cred.username});
      });
      menuItems.push({ isDivider: true });
    }
    // if for any reason we display the menu without any credentials at least show the connect option
    // the value there is not used, at the end of the flow we will use the id from the response.
    menuItems.push({value: NewSalesforceConnectionValue, displayValue: Messages.connectToSalesforce_NewSalesforceConnection()});
    return menuItems;
  };

  const executeContextMenuCommand = (oauthId: number): void => {
    props.handleSelectedItem(oauthId);
  };

  const bottomLeftOrigin: OriginOptions = {
    vertical: VerticalOriginOption.bottom,
    horizontal: HorizontalOriginOption.left,
  };

  const dropdownButton = (): JSX.Element => {
    return <>
      <MenuButtonWidget
        aria-controls={ConnectToSalesforceMenuId}
        testId={`${ConnectToSalesforce}-dropdown`}
        kind={'outline'}
        className={integrationSettingConnectButton}
        density={'low'}
        ref={connectToSalesforceMenuAnchor}
        children={Messages.connectToSalesforce_ConnectToSalesforceButtonTag()}
        isOpen={isMenuOpen}
        onClick={menuClick}
      />
      {isMenuOpen &&
      <FlyoutListMenuWidget
        id={ConnectToSalesforceMenuId}
        menuItemInfos={buildMenuItems()}
        testId={ConnectToSalesforce} //widget adds suffix
        toggleEl={connectToSalesforceMenuAnchor.current}
        anchorEl={connectToSalesforceMenuAnchor.current}
        anchorOrigin={bottomLeftOrigin}
        onSelect={value => onSelectContextMenuItem(value)}
        requestCloseAll={closeMenu}
      />}
    </>;
  };

  return dropdownButton();
}

export default ConnectToSalesforceDropdown;
